/**
 * Handle behaviour of showing animation of astronaut one time and then save it in a cookie
 */
jQuery(function($) {

	// Add animate class to astronaut when there's no cookie
	function startAnimation() {
		var cookie = document.cookie;

		if (cookie.indexOf('preventAnimation=true') === -1) {
			$('.astronaut').addClass('animate');

			setPreventAnimationCookie();
		}
	}

	// Set cookie for animation (24 hours)
	function setPreventAnimationCookie() {
		var date = new Date();
		date.setTime(date.getTime() + 1000 * 60 * 60 * 24);
		document.cookie = 'preventAnimation=true; expires=' + date.toUTCString() + '; path=/';
	}

	startAnimation();
});